import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseModel } from '../models/commons/response.model';

@Injectable()
export class AppUtilService {

    constructor() { }

    /** Response errors handling from api (System response errors)
     *  @InputParam Response error that received when invoke api.
     *  @Note This function has not been handle. It waits for you.
     * */
    systemErrorHandle(responseError: HttpErrorResponse): void {
        // TODO Something...
        const message = responseError.error ? responseError.error.responseText : responseError.message
        console.error(`Have error occcurs when invoke api: ${responseError.url}\n Status: ${responseError.status}\n Message: ${message}`)
    }

    /** Response errors handling from api (Developer response errors)
    *  @InputParam Response error that received when invoke api.
    *  @Note This function has not been handle. It waits for you.
    * */
    developerErrorHandle(responseError: ResponseModel<any>): void {
        // TODO Something...
        console.error(`Have error occcurs when invoke api\n Status: ${responseError.error_code}\n Message: ${responseError.message}`)
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/utils/app-util.service.ts